var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 28,
    viewBox: "0 0 28 28",
    width: 28,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.33301 2.33301h23.3333v23.3333h-23.3333z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.9974 2.33301-.1566.53173v15.42836l.1566.1562 7.1615-4.2333z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.0064 2.33301-7.16167 11.88299 7.16167 4.2333v-7.4885z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9974 19.8033-.0882.1076v5.4958l.0882.2576 7.1659-10.092z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.0064 25.6643v-5.861l-7.16167-4.231z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 18.4572 7.1615-4.2332-7.1615-3.2552z",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.84473 14.224 7.16167 4.2332v-7.4884z",
    fill: "#eee"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nft.1b89ae515ba727956dabc34c3bb2db64.svg";